// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tlIrb","content":"styles_content__1ojvC"};